import './Footer3.css';

import React from 'react';
import facebookIcon from '../../assets/pullman/home/footer-socialmedia-facebook.svg';
import footerContactIcon from '../../assets/pullman/home/footer-contact-center.svg';
import footerEmailIcon from '../../assets/pullman/home/footer-email.svg';
import footerLocationIcon from '../../assets/pullman/home/footer-location.svg';
import instagramIcon from '../../assets/pullman/home/footer-socialmedia-instagram.svg';
import linkedinIcon from '../../assets/pullman/home/footer-socialmedia-linked-in.svg';
import pullManCargoIcon from '../../assets/pullman/home/footer-contigo-logo.svg';

const footerLeftArr = [
  { label: '123456789', image: footerContactIcon },
  { label: 'something@gmail.com', image: footerEmailIcon },
  { label: 'santiago, chile', image: footerLocationIcon },
];

const footerMiddleArr = [
  'pullman carg',
  'tandem',
  'conoce tus derectos',
  'politicas',
  'terminos y condicinos',
];

const footerRightArr = [
  { link: '', image: facebookIcon },
  { link: '', image: instagramIcon },
  { link: '', image: linkedinIcon },
];

function Footer3() {

  return (
    <div className=" footer3 ">
      <div className="footer-top-background-image"></div>
      <div className=" footer-container3">
        <div className="new-container ">
          <div className="new-sub-container">
            <div className="footer-left">
              {footerLeftArr.map(item => (
                <div className="footer-left__item">
                  <img src={item.image} className="col-1__img" alt="" />
                  <span>{item.label}</span>
                </div>
              ))}
            </div>
            <div className="footer-middle">
              <div className="footer-middle__item">
                <h1 className="bold">Pullman</h1>
                <span className="underline"></span>
                <ul>
                  {footerMiddleArr.map(item => (
                    <li className="footer-middle__list">{item}</li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="footer-right">
              <div className="footer-right__item">
                <img src={pullManCargoIcon} alt="" />
                <div className="footer-right__social-media">
                  <ul>
                    <li>
                      <a href="#">Santiago</a>
                    </li>
                    {footerRightArr.map(item => (
                      <li>
                        <a href={item.link}>
                          <img src={item.image} alt="" />
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer3;



// WEBPACK FOOTER //
// ./src/features/themes/common/footer/Footer3.js